export default Object.freeze({
  LICENSE_UPDATE_LOGS_TITLE: 'License Update Logs',
  USER_LOGIN_REPORT_TITLE: 'User Logins Report',
  LICENSE_UPDATE_LOGS_TABLE_HEADERS: [
    { label: 'License Issuer', key: 1, db_key: 'license_issuer' },
    { label: 'State Name', key: 2, db_key: 'state' },
    { label: 'Updated Date', key: 3, db_key: 'log_date' },
    { label: '# of Licenses Added', key: 4, db_key: 'added_count' },
    { label: '# of Licenses Updated', key: 5, db_key: 'update_count' },
    { label: '# of Licenses Removed', key: 6, db_key: 'delete_count' },
    { label: 'Upload Type', key: 7, db_key: 'upload_type' },
  ],
  USER_LOGIN_REPORT_TABLE_HEADERS: [
    { label: 'User Name', key: 1, db_key: 'first_name' },
    { label: 'Company', key: 2, db_key: 'company' },
    { label: 'Logged in Date', key: 2, db_key: 'company' },
    { label: 'Duration', key: 2, db_key: 'duration' },
    { label: 'Activity Log', key: 2, db_key: '' },
  ],
  USER_LOGIN_RECORDS_DEFAULT_LIMIT: 10,
  DEFAULT_SORTING_PARAMETER: 'first_name',
  DEFAULT_SORTING_PARAMETER_LICENSE: 'log_date',
  USER_LOGIN_RECORDS_STARTING_PAGE: 1,
  TOST_TYPE_SUCCESS: 'success',
  TOST_TYPE_ERROR: 'error',
  USER_PERMISSION_ROLE_ADMIN: 'ADMIN',
  GET_USER_LOGIN_RECORDS_DEFAULT_PARAMETERS: {
    page: 1,
    limit: 10,
    asc: ['first_name'],
  },
  GET_LICENSE_LOGS_DEFAULT_PARAMETERS: {
    page: 1,
    limit: 10,
    sort_by: 'log_date',
    sort_order: 'asc',
  },
});
